module.exports = __webpack_public_path__ + "img/report.706c8d0e.jpg";